import { Row, Col, Typography, Divider, Flex, Table } from "antd";
import { formatCurrency, formatDate, formatBusinessDealStatus } from "../../../helpers/helpers";
import { GLOBAL_CONSTANTS } from "../../../constants/constants";
import { isSupplyChainCategory } from "../../../helpers/dealCategoryProducts";

const { Text } = Typography;

const DealDetails = ({ deal }) => {
    const isSupplyChain = isSupplyChainCategory(deal?.dealCategoryId || deal?.dealType);
    const labelStyle = { fontWeight: 600 };
    const valueStyle = { color: "#004A2A", fontWeight: 500 };

    const renderField = (label, value) => (
        <Flex justify="space-between">
            <Text style={labelStyle}>{label}</Text>
            <Text style={valueStyle}>{value}</Text>
        </Flex>
    );

    return (
        <div className="deal-details-card-container">
            <div className="card-header-container">
                <Row gutter={[0, 16]} justify="space-between" align="middle">
                    <Col>
                        <Row gutter={[48, 16]} justify="start" align="middle">
                            <Col>
                                <Text><strong>Deal ID: </strong>{deal?.dealId}</Text>
                            </Col>
                            <Col>
                                <Text><strong>Enterprise Name: </strong>{deal?.enterpriseName}</Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Text strong>Deal Status </Text>
                        <Text className="deal-status-tag">{formatBusinessDealStatus(deal?.dealStatus)}</Text>
                    </Col>
                </Row>
            </div>

            <Row className="details-row-container" gutter={[0, 0]}>
                <Col xs={24} md={12} className="details-equal-col">
                    <div className="details-col-container">
                        {renderField(isSupplyChain ? "Purchase Order Amount:" : "Invoice Amount:", formatCurrency(deal?.invoiceAmount))}
                        {isSupplyChain && renderField("Material Cost:", formatCurrency(deal?.totalMaterialCost))}
                        {renderField("Approved Amount:", formatCurrency(deal?.approvedAmount))}
                        {renderField("Funded Amount:", formatCurrency(deal?.fundedAmt))}
                        {renderField("Disbursed Amount:", formatCurrency(deal?.disbursedAmount))}
                        {/* {renderField("Enterprise Received Amount:", formatCurrency(deal?.enterpriseReceivedAmount))} */}
                        {renderField("Amount Repaid to Investors:", formatCurrency(deal?.amountRepaidToInvestor))}
                        {renderField("Balance Amount:", formatCurrency(deal?.balanceAmount))}
                    </div>
                </Col>

                <Col xs={0} md={1} style={{ display: "flex", justifyContent: "center" }}>
                    <Divider type="vertical" style={{ height: "100%", borderLeft: "1px solid #CBD5E2", margin: 0 }} />
                </Col>

                <Col xs={24} md={11} className="details-equal-col">
                    <div className="details-col-container">
                        {renderField("Expiry Date:", formatDate(deal?.expiryDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Approved Date:", formatDate(deal?.approvedDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Expected Repayment Date:", formatDate(deal?.expectedRepaymentDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Disbursed Date:", formatDate(deal?.disbursedDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Actual Repayment Date:", formatDate(deal?.actualRepaymentDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Settled Date:", formatDate(deal?.settledDate) || GLOBAL_CONSTANTS.NA)}
                        {renderField("Tenure:", `${deal?.tenure} days`)}
                    </div>
                </Col>
            </Row>

            <Divider style={{ border: "1px solid #CBD5E2", margin: 0 }} />

            <Row className="details-row-container" gutter={[0, 0]}>
                <Col xs={24} md={12} className="details-equal-col">
                    <div className="details-col-container">
                        {renderField("Amount Repaid to Business:", formatCurrency(deal?.amountRepaidToBusiness))}
                        {renderField("Amount Repaid to Karncy:", formatCurrency(deal?.amountRepaidToKarncy))}
                    </div>
                </Col>

                <Col xs={0} md={1} style={{ display: "flex", justifyContent: "center" }}>
                    <Divider type="vertical" style={{ height: "100%", borderLeft: "1px solid #CBD5E2", margin: 0 }} />
                </Col>

                <Col xs={24} md={11} className="details-equal-col">
                    <div className="details-col-container">
                        {renderField("Penalty Fees:", formatCurrency(deal?.penaltyFees))}
                        {renderField(
                            "Interest Rate:",
                            `${(parseFloat(deal?.discountRate || 0) * 100).toFixed(2)}%`
                        )}
                    </div>
                </Col>
            </Row>

            {deal?.supplierAllocations?.length > 0 && (
                <>
                    <Divider style={{ border: "1px solid #CBD5E2", margin: 0 }} />
                    <div className="supplier-breakdown-container" style={{ padding: "20px" }}>
                        <Text className="supplier-breakdown-title" strong style={{ fontSize: 16 }}>
                            Supplier Breakdown
                        </Text>
                        <Table
                            dataSource={deal.supplierAllocations}
                            rowKey={(record) => record.supplierId || record.supplierName}
                            pagination={false}
                            tableLayout="fixed"
                            style={{ marginTop: 12 }}
                            columns={[
                                {
                                    title: "Supplier Name",
                                    dataIndex: "supplierName",
                                    key: "supplierName",
                                    align: "left",
                                    width: "60%",
                                    render: (val, record) => val || record.supplierId || GLOBAL_CONSTANTS.NA,
                                },
                                {
                                    title: "Allocated Amount",
                                    dataIndex: "allocatedAmount",
                                    key: "allocatedAmount",
                                    align: "right",
                                    width: "40%",
                                    render: (val) => formatCurrency(val),
                                },
                            ]}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default DealDetails;
